import { FC } from 'react';
import { IonFooter } from '@ionic/react';
import { AllieFooterProps } from './Footer.types';

export const AllieFooter: FC<AllieFooterProps> = (props) => (<IonFooter {...props} />);
